import { render, staticRenderFns } from "./VisualizarNotificacoesDialog.vue?vue&type=template&id=71d7dbe9"
import script from "./VisualizarNotificacoesDialog.vue?vue&type=script&lang=js"
export * from "./VisualizarNotificacoesDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports